import React, { useState, useContext } from 'react'
import { Formik, Field, FieldArray, ErrorMessage } from 'formik'
import { Form, Row, Col, Button } from 'react-bootstrap'

import api from '../../services/api'
import AlertCustom from '../alertCustom/index.js'
import BtnLoader from '../buttons/loader/index.js'
import StoreContext from '../../components/storage/context'
import errorHandlerShow from '../errorHandlerShow/index.js'
import SelectWithValidation from '../fields/selectWithValidation/index.js'
import ControlWithValidation from '../fields/controlWithValidation/index.js'
import SelectWithValidationInfo from '../fields/selectWithValidationInfo/index.js'
import ControlWithValidationInfo from '../fields/controlWithValidationInfo/index.js'
import AutoCompleteFieldsIntegrationLayer from '../autoCompleteFieldsIntegrationLayer/index.js'

// schema validation
import * as schema from '../schemaValidation/index.js'

import './styles.css'

const IntegrationLayerSystem = () => {
    const { token, pk_user, setToken } = useContext(StoreContext);

    const [loading, setLoading] = useState(false);
    const [systemType, setSystemType] = useState("");
    const [showAlert, setShowAlert] = useState(false);
    const [alert, setAlert] = useState({header: '', message: '', type: '', options_btn: []});

    const setSystem = (values) => {
        api.post('integration-layer/systems', {
            ...values,
            active: values.active === "true",
            scan_unprocessed_files: values.scan_unprocessed_files === "true"
        }, {
            params: {'pk_user': pk_user},
            headers: {'Authorization': token}
        }).then(response => {
            setAlert({
                header: "Status do cadastro do sistema",
                message: "O sistema " + values.system_name + " foi cadastrado com sucesso.",
                type: 'success',
                options_btn: []
            })

            // show alert to users
            setShowAlert(true)
            setLoading(false)
        }).catch(error => {
            errorHandlerShow(error, setToken, setAlert, setShowAlert)
            setLoading(false)
        })
    }

    const getSystem = async ({ system_name }) => {
        try {
            let hasSystem = false
            const response = await api.get('integration-layer/systems', {
                params: {'pk_user': pk_user, 'system_name': system_name},
                headers: {'Authorization': token}
            })

            const { system, message } = response.data
            
            if (system) {
                setAlert({
                    header: "Status do cadastro do sistema",
                    message: message,
                    type: 'danger',
                    options_btn: []
                })

                // show alert to users
                setShowAlert(true)
                hasSystem = true
            }
            setLoading(false)

            return hasSystem
        } catch (error) {
            errorHandlerShow(error, setToken, setAlert, setShowAlert)
            setLoading(false)
            return false
        }
    }

    const onSubmitSystem = (values) => {
        setLoading(true)
        getSystem(values).then(hasSystem => {
            if (!hasSystem) setSystem(values)
        })
    }

    return (
        <div className="integration-layer-entity-container">

            <AlertCustom
                alert={alert}
                showAlert={showAlert}
                setShowAlert={setShowAlert}
            />

            <Row className="mb-3">
                <SelectWithValidation
                    key="systemType"
                    Col={Col}
                    type="text"
                    label="system_type"
                    name="systemType"
                    placeholder=""
                    value={systemType}
                    handleChange={(event) => setSystemType(event.target.value)}
                    options={["", "S3", "SFTP", "FTP", "API"]}
                    readOnly={false}
                />
                <Col xs={10}/>
            </Row>

            {systemType === "S3" ?
                <RegisterS3System
                    loading={loading}
                    systemType={systemType}
                    schema={schema.SystemS3Schema}
                    onSubmitSystem={onSubmitSystem}
                />
            : null}

            {systemType === "FTP" || systemType === "SFTP" ?
                <RegisterSFTPSystem
                    loading={loading}
                    systemType={systemType}
                    schema={schema.SystemSFTPSchema}
                    onSubmitSystem={onSubmitSystem}
                />
            : null}

            {systemType === "API" ?
                <RegisterAPISystem
                    systemType={systemType}
                    loading={loading}
                    schema={schema.SystemAPISchema}
                    onSubmitSystem={onSubmitSystem}
                />
            : null}

        </div>
    );
}


const RegisterS3System = ({
    schema,
    onSubmitSystem,
    loading,
    systemType
}) => (
    <Formik
        initialValues={{
            system_name: '',
            active: '',
            company: '',
            desc_system: '',
            host: '',
            system_type: systemType
        }}
        validationSchema={schema}
        onSubmit={(values) => onSubmitSystem(values)}
        validateOnChange={true}
        validateOnBlur={true}
        enableReinitialize={true}
    >
    {({
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        setValues,
        touched,
        isValid,
        errors,
    }) => (
        <Form noValidate onSubmit={handleSubmit}>
            

            <S3SystemRows
                values={values}
                setValues={setValues}
                errors={errors}
                handleChange={handleChange}
                touched={touched}
            />

            <div className="mf-register-next mf-register-next-only mf-register-save">
                <BtnLoader
                    loading={loading}
                    messageNotLoading="Salvar"
                    messageLoading="Salvando"
                    style={"btn-loader-135px"}
                    variant={"success"}
                    hasOnClick={true}
                />
            </div>

        </Form>
    )}
    </Formik>
)


const RegisterSFTPSystem = ({
    schema,
    entity,
    fields,
    setFields,
    onSubmitSystem,
    readOnly,
    loading,
    alert,
    setAlert,
    showAlert,
    systemType,
    setShowAlert,
    loadingShow,
    loadingOverwrite
}) => (
    <Formik
        initialValues={{
            system_name: '',
            active: '',
            company: '',
            desc_system: '',
            host: '',
            key_sm: '',
            port: '',
            system_type: systemType,
            scan_unprocessed_files: ''
        }}
        validationSchema={schema}
        onSubmit={(values) => onSubmitSystem(values)}
        validateOnChange={true}
        validateOnBlur={true}
        enableReinitialize={true}
    >
    {({
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        setValues,
        touched,
        isValid,
        errors,
    }) => (
        <Form noValidate onSubmit={handleSubmit}>
            <AlertCustom
                alert={alert}
                values={values}
                showAlert={showAlert}
                setShowAlert={setShowAlert}
                loadingShow={loadingShow}
                loadingOverwrite={loadingOverwrite}
            />

            <SFTPSystemRows
                values={values}
                setValues={setValues}
                errors={errors}
                handleChange={handleChange}
                touched={touched}
            />

            <div className="mf-register-next mf-register-next-only mf-register-save">
                <BtnLoader
                    loading={loading}
                    messageNotLoading="Salvar"
                    messageLoading="Salvando"
                    style={"btn-loader-135px"}
                    variant={"success"}
                    hasOnClick={true}
                />
            </div>

        </Form>
    )}
    </Formik>
)


const RegisterAPISystem = ({
    schema,
    entity,
    fields,
    setFields,
    onSubmitSystem,
    readOnly,
    loading,
    alert,
    setAlert,
    showAlert,
    systemType,
    setShowAlert,
    loadingShow,
    loadingOverwrite
}) => (
    <Formik
        initialValues={{
            system_name: '',
            active: '',
            base_url: '',
            company: '',
            desc_system: '',
            key_sm: '',
            system_type: systemType
        }}
        validationSchema={schema}
        onSubmit={(values) => onSubmitSystem(values)}
        validateOnChange={true}
        validateOnBlur={true}
        enableReinitialize={true}
    >
    {({
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        setValues,
        touched,
        isValid,
        errors,
    }) => (
        <Form noValidate onSubmit={handleSubmit}>
            <AlertCustom
                alert={alert}
                values={values}
                showAlert={showAlert}
                setShowAlert={setShowAlert}
                loadingShow={loadingShow}
                loadingOverwrite={loadingOverwrite}
            />

            <APISystemRows
                values={values}
                setValues={setValues}
                errors={errors}
                handleChange={handleChange}
                touched={touched}
            />

            <div className="mf-register-next mf-register-next-only mf-register-save">
                <BtnLoader
                    loading={loading}
                    messageNotLoading="Salvar"
                    messageLoading="Salvando"
                    style={"btn-loader-135px"}
                    variant={"success"}
                    hasOnClick={true}
                />
            </div>

        </Form>
    )}
    </Formik>
)


const S3SystemRows = ({
    values,
    setValues,
    errors,
    touched,
    handleChange,
    readOnly
}) => {
    return (
    <div>
        <Row className="mb-3">
            <ControlWithValidation Col={Col}
                type="text"
                label="system_name"
                name="system_name"
                placeholder=""
                value={values.system_name}
                error={errors.system_name}
                handleChange={handleChange}
                readOnly={readOnly}
            />

            <SelectWithValidation 
                key="company"
                Col={Col}
                type="text"
                label="company"
                name="company"
                placeholder=""
                value={values.company}
                error={errors.company}
                handleChange={handleChange}
                options={["", "natura", "naturaeco", "avon", "thebodyshop", "aesop"]}
                readOnly={readOnly}
                typeColumn="xs"
                valueColumn={2}
            />

            <SelectWithValidation
                key="active"
                Col={Col}
                type="number"
                label="active"
                name="active"
                placeholder=""
                value={values.active}
                error={errors.active}
                handleChange={handleChange}
                options={["", "false", "true"]}
                readOnly={readOnly}
                typeColumn="xs"
                valueColumn={2}
            />

            <Col xs={3} />
        </Row>

        <Row>
            <ControlWithValidation Col={Col}
                type="text"
                label="desc_system"
                name="desc_system"
                placeholder=""
                value={values.desc_system}
                error={errors.desc_system}
                handleChange={handleChange}
                readOnly={readOnly}
            />

            <ControlWithValidation Col={Col}
                type="text"
                label="host"
                name="host"
                placeholder=""
                value={values.host}
                error={errors.host}
                handleChange={handleChange}
                readOnly={readOnly}
                typeColumn="xs"
                valueColumn={5}
            />

        </Row>

    </div>
)}


const SFTPSystemRows = ({
    values,
    setValues,
    errors,
    touched,
    handleChange,
    readOnly
}) => {
    return (
    <div>
        <Row className="mb-3">
            <ControlWithValidation Col={Col}
                type="text"
                label="system_name"
                name="system_name"
                placeholder=""
                value={values.system_name}
                error={errors.system_name}
                handleChange={handleChange}
                readOnly={readOnly}
            />

            <SelectWithValidation 
                key="company"
                Col={Col}
                type="text"
                label="company"
                name="company"
                placeholder=""
                value={values.company}
                error={errors.company}
                handleChange={handleChange}
                options={["", "natura", "naturaeco", "avon", "thebodyshop", "aesop"]}
                readOnly={readOnly}
                typeColumn="xs"
                valueColumn={2}
            />

            <SelectWithValidation
                key="active"
                Col={Col}
                type="number"
                label="active"
                name="active"
                placeholder=""
                value={values.active}
                error={errors.active}
                handleChange={handleChange}
                options={["", "false", "true"]}
                readOnly={readOnly}
                typeColumn="xs"
                valueColumn={2}
            />

            <ControlWithValidation Col={Col}
                type="text"
                label="key_sm"
                name="key_sm"
                placeholder=""
                value={values.key_sm}
                error={errors.key_sm}
                handleChange={handleChange}
                readOnly={readOnly}
            />

            <ControlWithValidation Col={Col}
                type="text"
                label="port"
                name="port"
                placeholder=""
                value={values.port}
                error={errors.port}
                handleChange={handleChange}
                readOnly={readOnly}
                typeColumn="xs"
                valueColumn={1}
            />

        </Row>

        <Row>
            <ControlWithValidation Col={Col}
                type="text"
                label="desc_system"
                name="desc_system"
                placeholder=""
                value={values.desc_system}
                error={errors.desc_system}
                handleChange={handleChange}
                readOnly={readOnly}
            />

            <ControlWithValidation Col={Col}
                type="text"
                label="host"
                name="host"
                placeholder=""
                value={values.host}
                error={errors.host}
                handleChange={handleChange}
                readOnly={readOnly}
                typeColumn="xs"
                valueColumn={5}
            />

            <SelectWithValidationInfo
                key="scan_unprocessed_files"
                Col={Col}
                type="number"
                label="scan_unprocessed_files"
                name="scan_unprocessed_files"
                placeholder=""
                value={values.scan_unprocessed_files}
                error={errors.scan_unprocessed_files}
                handleChange={handleChange}
                options={["", "false", "true"]}
                readOnly={readOnly}
                typeColumn="xs"
                valueColumn={3}
                tooltip="Trata-se de funcionalidade de movimentação de arquivos da pasta raiz para&#0010;pasta 'processed' e de verificação, na pasta raiz, de arquivos não processados.&#0010;Para que esta funcionalidade esteja ativada é indispensável que haja permissão&#0010;de escrita e movimentação de arquivos para o usuário SFTP/FTP cadastrado."
            />

        </Row>

    </div>
)}


const APISystemRows = ({
    values,
    setValues,
    errors,
    touched,
    handleChange,
    readOnly
}) => {
    return (
    <div>
        <Row className="mb-3">
            <ControlWithValidation Col={Col}
                type="text"
                label="system_name"
                name="system_name"
                placeholder=""
                value={values.system_name}
                error={errors.system_name}
                handleChange={handleChange}
                readOnly={readOnly}
            />

            <SelectWithValidation 
                key="company"
                Col={Col}
                type="text"
                label="company"
                name="company"
                placeholder=""
                value={values.company}
                error={errors.company}
                handleChange={handleChange}
                options={["", "natura", "naturaeco", "avon", "thebodyshop", "aesop"]}
                readOnly={readOnly}
                typeColumn="xs"
                valueColumn={2}
            />

            <SelectWithValidation
                key="active"
                Col={Col}
                type="number"
                label="active"
                name="active"
                placeholder=""
                value={values.active}
                error={errors.active}
                handleChange={handleChange}
                options={["", "false", "true"]}
                readOnly={readOnly}
                typeColumn="xs"
                valueColumn={2}
            />

            <ControlWithValidation Col={Col}
                type="text"
                label="key_sm"
                name="key_sm"
                placeholder=""
                value={values.key_sm}
                error={errors.key_sm}
                handleChange={handleChange}
                readOnly={readOnly}
            />

        </Row>

        <Row>
            <ControlWithValidation Col={Col}
                type="text"
                label="desc_system"
                name="desc_system"
                placeholder=""
                value={values.desc_system}
                error={errors.desc_system}
                handleChange={handleChange}
                readOnly={readOnly}
            />

            <ControlWithValidation Col={Col}
                type="text"
                label="base_url"
                name="base_url"
                placeholder=""
                value={values.base_url}
                error={errors.base_url}
                handleChange={handleChange}
                readOnly={readOnly}
                typeColumn="xs"
                valueColumn={5}
            />

        </Row>

    </div>
)}


export default IntegrationLayerSystem;
